<template>
  <div>
    <div class="main">
      <div class="bigTitle">
        <span class="big">T</span> r e a t m e n t <span class="big margin">S</span> y n o p s i s
      </div>
      <div class="AllValue">
        <div class="leftValue">
          <img src="@/assets/img/colorfulMap.png" alt="">
        </div>
        <div class="rightValue">
          <div class="topValue">
            <div class="title">
              <span class="big">W</span>hat is the Treatment Synopsis?
            </div>
            <div class="topText">
              It is a monthly HCP quantitative study conducted by Holden across China. Certain diseases or topics are highlighted each month, and released as a monthly publication or included into the Holden Answer Platform
            </div>
          </div>
          <div class="bottomValue">
            <div class="title">
              <span class="big">C</span>overing the following areas:
            </div>
            <div class="bottomText">
              <div class="bottom">
                <div class="bottonLeft"><span>√</span> Usage: </div>
                <div class="bottomRight"> Uncovering top used drug usage across China by disease </div>
              </div>
              <div class="bottom">
                <div class="bottonLeft"><span>√</span> Treatment Distribution: </div>
                <div class="bottomRight">Geographical distribution of treatments, including hospital tiers and HCP seniority. </div>
              </div>
              <div class="bottom">
                <div class="bottonLeft"><span>√</span> Treatment Pain Points: </div>
                <div class="bottomRight">Ranked pain points & unmet needs by HCP and disease</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { advertisementFlow } from "@/api/api";

export default {
  created() {
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
        advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "TreatmentSynopsis",
          source: "",
          information: ""
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "TreatmentSynopsis",
          source: this.$route.query.source,
          information: ""
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
  }
};
</script>

<style scoped lang="scss">
* {
  font-family: "Nunito";
}
.main {
  padding: 50px 100px;
}
.bigTitle {
  font-size: 30px;
  .big {
    font-weight: 700;
    font-size: 40px;
  }
  .margin {
    margin-left: 20px;
  }
}
.AllValue {
  display: flex;
  .leftValue {
    width: 50%;
    img {
      width: 100%;
    }
  }
  .rightValue {
    width: 50%;
    .topValue,
    .bottomValue {
      margin-top: 50px;
      .title {
        font-size: 20px;
        margin-bottom: 15px;
        .big {
          font-size: 30px;
          font-weight: 700;
        }
      }
    }
    .bottomValue {
      .bottomText {
        .bottom {
          display: flex;
          margin-bottom: 10px;
          .bottonLeft {
            width: 25%;
            font-weight: 700;
            display: flex;
          }
          .bottomRight {
            width: 70%;
          }
        }
      }
    }
  }
}
</style>